<!-- TODO: rewire to the AI builder harness. This is the only thing that opens the selection
     menu, so commenting it out retires the popover in every host editor at once. The p-menu
     below stays: hosts hide it on scroll through the selectionMenu view child. -->
<!--
@if (hasAiDeveloperPermission()) {
  <button
    #selectionButton
    (click)="selectionMenu.toggle($event)"
    class="flx-ai-sparkles-cta floating-action"
    data-testid="ai-code-selection-button"
    flxButton
  >
    <flx-icon
      name="stars-flowx-yellow"
      class="w-4 h-4"
    />
  </button>
}
-->

<p-menu
  #selectionMenu
  [popup]="true"
  [model]="selectionMenuOptions"
  styleClass="mt-1 font-semibold flx-prime-menu"
  appendTo="body"
/>
